import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { Subject } from 'rxjs';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { chooseOptionsConstant, strengthAndUnitsOtherOptionsConstant, serviceConstants } from 'src/app/constants/service.constants';
import { DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { DatePipe } from '@angular/common';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { MessageBoxComponent } from '../../../message-box/message-box.component';
import { Document_Upload_File } from '../../../../models/common';
import { CommonService } from '../../../../services/common.service';
import { FilePreviewComponent } from 'src/app/common/document-summary/file-preview/file-preview.component';

import * as $ from 'jquery';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'configure-template-view',
  templateUrl: './configure-template-view.component.html',
  styleUrls: ['./configure-template-view.component.scss']
})
export class ConfigureTemplateViewComponent implements OnInit {
  formFields;
  @Input() public Content:any;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  formData: FormData;
  labDetailsForm: UntypedFormGroup;
  strengthAndUnitsOptions = strengthAndUnitsOtherOptionsConstant;
  ApplicationID: any;
  PatientID: any;
  document_attach_list: Document_Upload_File[] = [];
  ScreensList: any = [];
  ApplicationTypeList: any = [];
  FileName: any;
  FileID: any;
  tooltipValueTypes:any;
  tooltipValue: any;
  StatesList = [
    { "value": "0", "label": "InActive" },
    { "value": "1", "label": "Active" },
  ];
  MappedApplications: any = [];
  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    public commonService: CommonService,
    public datepipe: DatePipe    
  ) {
  }

  ngOnInit() {
    this.labDetailsForm = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      SCREEN_ID: new UntypedFormControl(""),
      TEMPLATE_NAME: new UntypedFormControl(""),
      State: new UntypedFormControl(""),
      IS_ACTIVE: new UntypedFormControl(true),
      ApplicationType: new UntypedFormControl(""),
    });

    if (this.Content.heading == "Edit" || this.Content.heading == "View") {
      this.summaryService.getScreenDataForEdit("api/ISTFileAttachments/EditTemplateDetails?TemplateID=" + this.Content.content.id).subscribe(criteria => {
      criteria["MappedApplications"].forEach(element =>
      {
        this.MappedApplications.push(element.value)
      });
        this.labDetailsForm.patchValue({
          ID: criteria["ID"],
          //SCREEN_ID: criteria["SCREEN_ID"],
          TEMPLATE_NAME: criteria["TEMPLATE_NAME"],
          State: criteria["State"],
          IS_ACTIVE: criteria["RECORD_STATE"],
          ApplicationType : this.MappedApplications
        });
        let abc=criteria["SCREEN_ID"].split(",");
        this.labDetailsForm.controls["SCREEN_ID"].setValue(abc);
        this.FileName = criteria["FileName"];
        this.FileID = criteria["FileID"];
        if (this.Content.heading == "View") {
          this.labDetailsForm.disable();
        }
      });

    }
    if(this.Content.heading == "Add")
    {
      this.defaultTypes();
    }
    this.getMasterData();
    this.getApplicationtypes();
  }

  defaultTypes()
  {
    this.getApplicationtypes();
    this.changeAppTypes("default");
  }

  changeVal($event) {
    setTimeout(() => {
    let selectedScreens= this.labDetailsForm.controls["SCREEN_ID"].value;
    if(selectedScreens != "" && selectedScreens != undefined && selectedScreens != null)
      {
        let screenLabel=this.ScreensList.filter((item)=>{
          return  selectedScreens.indexOf(item.value)>-1;
         })
         let labellist=[];
         screenLabel.forEach((item)=>{
           labellist.push(item.label);
         });
         this.tooltipValue =labellist.join(",");
      }
      else
      {
        this.tooltipValue = "";
      }
      
    }, 200);
  } 

  changeAppTypes($event)
  {
    setTimeout(() => {
      let selectedProg ;
      if ($event == "default") {
        this.MappedApplications=[];
        this.ApplicationTypeList.forEach(element => {
          this.MappedApplications.push(element.value);
        });
        this.labDetailsForm.controls["ApplicationType"].setValue(this.MappedApplications);
        selectedProg = this.labDetailsForm.controls["ApplicationType"].value;
      }

        selectedProg = this.labDetailsForm.controls["ApplicationType"].value;
        if (selectedProg != "" && selectedProg != undefined && selectedProg != null) {
          let TypeLabel = this.ApplicationTypeList.filter((item) => {
            return selectedProg.indexOf(item.value) > -1;
          })
           let labellist=[];
           TypeLabel.forEach((item)=>{
            labellist.push(item.label);
          });
           this.tooltipValueTypes =labellist.join(",");
        }
        else
        {
          this.tooltipValueTypes = "";
        }
    }, 200);
  }

  getApplicationtypes(){
    if(this.Content.content.MODULE_ID == "2")
      {
        this.Content.content.SUB_MODULE = "IST";
      }
      if(this.Content.content.MODULE_ID == "5")
        {
          this.Content.content.SUB_MODULE = "EAP";
        }
    let recordid=this.Content.content.id;
    if(this.Content.heading == "Add"){
      recordid="-1";
    }
    this.summaryService.masterData("api/ISTFileAttachments/GetApplicationTypes?moduleID="+ this.Content.content.MODULE_ID+"&subModule="+ this.Content.content.SUB_MODULE+"&RecordID=" +recordid).subscribe((result:any)=>{
     this.ApplicationTypeList = result;
    });
  }

  getMasterData() {
    this.summaryService.masterData("api/ISTFileAttachments/GetScreenNames?MODULE_ID=" + this.Content.content.MODULE_ID +"&TemplateID=" + this.Content.content.id+"&TemplateName="+this.Content.content.SUB_MODULE).subscribe(result => {
    this.ScreensList = result;
    this.ScreensList.forEach((item:any)=>
    {
      if(item.IsActive == false)
       item["icon"]="ieg_inactive_record";
    })
    });
  }
  DeleteUpload(file): void {
    if (file.Status == "Add") {
      let code = file.ID;
      this.document_attach_list = this.document_attach_list.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      file.Status = "Delete";
    }
  }

  DeleteSavedUpload(): void {
   var fileID = this.FileID;
   this.FileName= "";
   this.FileID= "";
   /*  this.summaryService.DeleteRecord("api/ISTFileAttachments/DeleteFile?FileID=" + fileID).subscribe(result => {
      this.FileName= "";
      this.FileID= ""; */
    /* }); */
  }
  DownloadFile(fileID) {
    var fileID = this.FileID;
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  ViewFile(fileID,fileName)
  {
    this.commonService.previewFile(fileID,fileName,"med");
    }
    
  uploadchange(event): void {
    if (this.document_attach_list == undefined || this.document_attach_list == null) {
      this.document_attach_list = [];
    }
    this.DeleteSavedUpload();
    //this.document_attach_list = [];
    var file = event.target.files[0].name;    
    var ext = file.match(/\.([^\.]+)$/)[1];
    var filesize = event.target.files[0].size;
    if (file != null && ((filesize > (1024 * 1024 * 10)) || (ext !='docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf'))) {
      this.commonService.ValidationBanner("Accepts only Word, PPT, Excel, Pdf, Text file types with maximum 10mb size");
      //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: "Accepts only Word, PPT, Excel, Text file types with maximum 10mb size"} } });
    }
    else{
    for (let i = 0; i < event.target.files.length; i++) {
      this.document_attach_list = [];
      let uploadFile = new Document_Upload_File();
      uploadFile.ID = ("" + (i + 1));
      uploadFile.DOCUMENT_NAME = event.target.files[i].name;
      uploadFile.File = event.target.files[i];
      uploadFile.Status = "Add";
      this.document_attach_list=[];
      this.document_attach_list.push(uploadFile);
    }
  }
  }
  SaveLabReports() {
    if (this.Validations()) { 
      var formData = this.labDetailsForm.value;

      var scrobj = this.ScreensList.filter(function (element) 
      {
        return formData.SCREEN_ID.indexOf(element.value)>-1;
      });
      let names=scrobj.map(x=>x.label).join(", ");      
      let ids= formData.SCREEN_ID.join(",");
      formData["SCREEN_ID"]=ids;
      formData["SCREEN_NAMES"] = names;
      formData["MODULEID"]=this.Content.content.MODULE_ID;
      formData["SUB_MODULE"] = this.Content.content.SUB_MODULE;

      formData['MappedAppTypesIDs'] = formData.ApplicationType.join(",");




      let tempList = this.ApplicationTypeList.filter((item) => {
        return   formData['MappedAppTypesIDs'].indexOf(item.value) > -1;
      });
      tempList.forEach((obj, index) => {
        if (index == 0)
          formData['MappedAppTypesNames'] = obj.label;
        else
        formData['MappedAppTypesNames'] = formData['MappedAppTypesNames'] + "," + obj.label;
      });

      formData.RECORD_STATE = formData.IS_ACTIVE == true ? 1 : 0;
      formData.TEMPLATE_NAME = formData.TEMPLATE_NAME == null ? null : formData.TEMPLATE_NAME==undefined?undefined:formData.TEMPLATE_NAME.trim();
      let formData1 = new FormData();
      if (this.document_attach_list != null && this.document_attach_list.length > 0) {
        for (let i = 0; i < this.document_attach_list.length; i++) {
          this.document_attach_list[i].TRANSACTION_ID = ("" + (i + 1));
          formData1.append(("" + (i + 1)), this.document_attach_list[i].File);
        }
      }
      
      formData1.append("ScreenData", JSON.stringify(formData));

      if (this.Content.heading == "Edit") {
        this.summaryService.FilesInsert("api/ISTFileAttachments/Update", formData1).subscribe(result => {
          if (result.Status==0){
            this.commonService.SuccessBanner(result.Message);
            
            this.modalRef.close();
          }
          else
          {
            this.commonService.ValidationBanner(result.Message);
            //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: result.Message } } });
          }
        });
      }
      else
      {
        this.summaryService.FilesInsert("api/ISTFileAttachments/Insert", formData1).subscribe(result => {
        if (result.Status==0){
          this.commonService.SuccessBanner(result.Message);
          
          this.modalRef.close();
        }
        else
        {
          if(formData["SCREEN_ID"]!=null && formData["SCREEN_ID"]!=undefined)
          {
             let list=formData["SCREEN_ID"];
             if(list!=null && list!=undefined)
             {
              let abc=formData["SCREEN_ID"].split(",");
              this.labDetailsForm.controls["SCREEN_ID"].setValue(abc);
             }
           
          }
          
          this.commonService.ValidationBanner(result.Message);
          //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: result.Message } } });
        }
        });  

      }
     
    }
  }

  Validations(): boolean {
    var message = "";
    var isValid = true;
    var formData = this.labDetailsForm.value;


    if (formData.TEMPLATE_NAME === null || formData.TEMPLATE_NAME === "" || formData.TEMPLATE_NAME === undefined) {
      $("#TEMPLATE_NAME").addClass("ng-touched ng-invalid validate-error");
      $("#TEMPLATE_NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Document Template Name<br/>";
      isValid = false;
    }else if(formData.TEMPLATE_NAME !=null && formData.TEMPLATE_NAME != undefined&&formData.TEMPLATE_NAME.trim()==""){
      $("#TEMPLATE_NAME").addClass("ng-touched ng-invalid validate-error");
      $("#TEMPLATE_NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Document Template Name<br/>";
      isValid = false;
    } 
    else {
      $("#TEMPLATE_NAME").addClass("ng-untouched ng-valid");
      $("#TEMPLATE_NAME").removeClass("ng-touched ng-invalid validate-error");
    }
    
    if (formData.SCREEN_ID == null || formData.SCREEN_ID == "" || formData.SCREEN_ID == undefined) {
      $("#SCREEN_ID").addClass("ng-touched ng-invalid validate-error");
      $("#SCREEN_ID").removeClass("ng-untouched ng-valid");
      message += "Please select Applicable Screens<br/>";
      isValid = false;
    } else {
      $("#SCREEN_ID").addClass("ng-untouched ng-valid");
      $("#SCREEN_ID").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.ApplicationType == null || formData.ApplicationType == "" || formData.ApplicationType == undefined) {
      $("#ApplicationType").addClass("ng-touched ng-invalid validate-error");
      $("#ApplicationType").removeClass("ng-untouched ng-valid");
      message += "Please select Application Type<br/>";
      isValid = false;
    }
    else if (formData.ApplicationType != null && formData.ApplicationType != "" && formData.ApplicationType != undefined)
    {
      let selectedIDs = formData.ApplicationType.join(",")
      let InactiveAvilable = this.ApplicationTypeList.filter((item) => {
        return (selectedIDs.indexOf(item.value) > -1 && item.IsActive == false);
      })[0];
      if (InactiveAvilable != undefined && InactiveAvilable != null) {
        $("#ApplicationType").addClass("ng-touched ng-invalid validate-error");
        $("#ApplicationType").removeClass("ng-untouched ng-valid");
        message += "Please remove inactive application type to save the details<br/>";
        isValid = false;
      }
    }
     else {
      $("#ApplicationType").addClass("ng-untouched ng-valid");
      $("#ApplicationType").removeClass("ng-touched ng-invalid validate-error");
    }

    if ((this.document_attach_list != null && this.document_attach_list.length > 0) || (this.FileName != "" && this.FileName!=undefined)) {
    }
    else {
      message += "Please Upload Document<br/>";
      isValid = false;
    }
    if (!isValid)
    this.commonService.ValidationBanner(message);
      //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: message } } });
    return isValid;
  }

  

}
